module.exports = __webpack_public_path__ + "img/the-field-gal-6.2cda70c8.jpg";